import styled, { css, keyframes } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

const slideInUp = keyframes`
    from {
        transform: translateY(59%);
        visibility: visible
    }

    to {
        transform: translateY(0)
    }
`;

export const StyledActionsContainer = styled.div<{ variant: "chatPage" | "gatePage"; topOffset: number }>`
    width: 40px;
    height: 88px;
    position: absolute;
    top: ${({ variant, topOffset }) => (variant === "chatPage" ? 24 + topOffset : 75 + topOffset)}px;
    left: 28px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    z-index: 11;
    box-sizing: border-box;
    animation: ${({ variant }) =>
        variant === "chatPage"
            ? css`
                  ${slideInUp} 500ms ease-out forwards
              `
            : "none"};
`;

export const StyledActionButton = styled(IconButton)<{ isActive?: boolean }>`
    ${SWReactIcons}[data-automation-icon-name="history"] {
        width: 16px;
        height: 16px;
        & svg {
            width: 16px;
            height: 16px;
        }
    }
    ${SWReactIcons} {
        & svg > path {
            fill: ${colorsPalettes.carbon[300]};
        }
    }
    &:hover {
        ${SWReactIcons} {
            & svg > path {
                fill: ${colorsPalettes.carbon[300]};
            }
        }
    }
    ${({ isActive }) =>
        isActive &&
        css`
            background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};
        `}
`;
